module.exports = __webpack_public_path__ + "static-v-shop/1786471049803/img/logo_visa.5f04499f.svg";